<!-- Подтверждение расхода и служебный источник записи. -->
<template>
  <BaseFormSection title="Подтверждение" icon="check">
    <BaseFormField label="Статус">
      <div class="expense-summary-value">
        <div v-if="expense.accepter_id" class="status-box">
          <span class="status-margin accept-text">Подтверждено</span>
          <span class="status-margin accepter">
            {{ accepterName }}
          </span>
          <span
            v-if="expense.accepted_at"
            class="status-margin accept-date"
          >
            {{ formatDateAndTimeLocal(expense.accepted_at) }}
          </span>
        </div>
        <div v-else class="status-box">
          <span class="status-margin none-accept-text">
            Не подтверждено
          </span>
          <base-button
            class="accept-btn"
            :disabled="isSubmitting"
            @click="$emit('accept', expense.id)"
          >
            Подтвердить
          </base-button>
        </div>
      </div>
    </BaseFormField>

    <BaseFormField v-if="expense.source_type" label="Источник">
      <div class="expense-summary-value">
        <div
          class="source-type-badge"
          :class="`source-type--${expense.source_type}`"
        >
          {{ sourceTypeLabel(expense.source_type) }}
        </div>
      </div>
    </BaseFormField>
  </BaseFormSection>
</template>

<script>
import { formatDateAndTimeLocal } from "@/utils/dateUtils";

export default {
  name: "ExpenseConfirmationSection",

  props: {
    accepterName: { type: String, required: true },
    expense: { type: Object, required: true },
    isSubmitting: { type: Boolean, required: true },
    sourceTypeLabel: { type: Function, required: true },
  },

  emits: ["accept"],

  methods: {
    formatDateAndTimeLocal,
  },
};
</script>

<style scoped>
.expense-summary-value {
  display: flex;
  align-items: center;
  width: 100%;
  min-height: 56px;
  padding: 12px 16px;
  box-sizing: border-box;
  background: #f9fafb;
  border-radius: 8px;
  border: 1px solid var(--color-grey);
}

.status-box {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  width: 100%;
  flex-wrap: wrap;
}

.accept-text {
  color: var(--color-green);
  font-weight: 600;
  font-size: 14px;
}

.none-accept-text {
  color: #999;
  font-size: 14px;
}

.accepter {
  font-size: 14px;
  color: var(--color-dark);
}

.accept-date {
  font-size: 13px;
  color: #999;
}

.source-type-badge {
  display: inline-flex;
  align-items: center;
  padding: 4px 10px;
  border-radius: 20px;
  font-size: 13px;
  font-weight: 500;
}

.source-type--manual {
  background: #dbeafe;
  color: var(--color-blue);
}

.source-type--bank_statement {
  background-color: #d1fae5;
  color: #059669;
}
</style>
